import * as React from 'react';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import {
  Box,
  GDSHeadingLevel,
  HeadingText,
  Image,
} from '@leagueplatform/genesis-core';

export const NODE_TYPE_BENEFITS_SECTION_HEADER = 'benefitSectionHeader';

interface HeadingIcon {
  url?: string;
  description?: string;
}

type BenefitsSectionHeaderProps = {
  heading: string;
  headingLevel?: GDSHeadingLevel;
  icon?: HeadingIcon;
};

type BenefitsSectionHeaderNode = MasonryEngineNode<
  typeof NODE_TYPE_BENEFITS_SECTION_HEADER,
  BenefitsSectionHeaderProps,
  {},
  {}
>;

export type BenefitsSectionHeaderRendererProps =
  MasonryEngineNodeRendererProps<BenefitsSectionHeaderNode>;

export function BenefitsSectionHeaderRenderer({
  heading,
  headingLevel = '2',
  icon,
}: BenefitsSectionHeaderRendererProps) {
  const { url, description = '' } = icon || {};
  return (
    <Box
      css={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '$threeQuarters',
      }}
    >
      {url && (
        <Box>
          <Image css={{ width: 42 }} src={url} alt={description} />
        </Box>
      )}
      <Box css={{ display: 'flex', alignItems: 'center' }}>
        <HeadingText size="lg" level={headingLevel}>
          {heading}
        </HeadingText>
      </Box>
    </Box>
  );
}
